import React from 'react';
import './ProgressModal.css';

const ProgressModal = ({ isVisible, currentStep, progress, fileName, totalSteps, steps, isError = false, errorMessage = '', onClose }) => {
  if (!isVisible) return null;

  return (
    <div className="progress-modal-overlay">
      <div className="progress-modal">
        <div className="progress-modal-header">
          <h2>{isError ? '验证失败' : '添加游戏中...'}</h2>
          {!isError && (
            <div className="progress-step-indicator">
              步骤 {currentStep} / {totalSteps}
            </div>
          )}
        </div>

        {isError ? (
          <div className="error-content">
            <div className="error-icon">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
              </svg>
            </div>
            <div className="error-message">
              <h3>无法提交表单</h3>
              <p>{errorMessage}</p>
            </div>
          </div>
        ) : (
          <div className="progress-steps-container">
            {steps.map((step, index) => (
              <div 
                key={index} 
                className={`upload-progress-step ${
                  index < currentStep - 1 ? 'completed' : 
                  index === currentStep - 1 ? 'active' : 'pending'
                }`}
              >
                <div className="upload-step-icon">
                  {index < currentStep - 1 ? (
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                    </svg>
                  ) : index === currentStep - 1 ? (
                    <div className="upload-step-spinner">
                      <div className="upload-spinner"></div>
                    </div>
                  ) : (
                    <span>{index + 1}</span>
                  )}
                </div>
                <div className="upload-step-content">
                  <div className="upload-step-title">{step.title}</div>
                  <div className="upload-step-description">{step.description}</div>
                  {index === currentStep - 1 && fileName && (
                    <div className="upload-current-file">
                      正在处理: {fileName}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}

        {!isError && progress > 0 && (
          <div className="progress-bar-container">
            <div className="progress-bar">
              <div 
                className="progress-bar-fill" 
                style={{ width: `${progress}%` }}
              ></div>
            </div>
            <div className="progress-text">{progress}%</div>
          </div>
        )}

        <div className="progress-modal-footer">
          {isError ? (
            <button 
              className="error-close-button"
              onClick={onClose || (() => window.location.reload())}
            >
              关闭并重试
            </button>
          ) : (
            <div className="progress-message">
              请勿关闭此页面，上传正在进行中...
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProgressModal;
